var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube24Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6964 5.32136C20.2493 5.14255 19.7507 5.14255 19.3036 5.32136L8.76869 9.53534C8.53657 9.62819 8.53566 9.95644 8.76725 10.0506L19.8954 14.5742C19.9625 14.6014 20.0375 14.6014 20.1046 14.5742L31.2327 10.0506C31.4643 9.95644 31.4634 9.62819 31.2313 9.53534L20.6964 5.32136ZM18.4941 33.5171C18.6765 33.5901 18.875 33.4557 18.875 33.2592V16.7751C18.875 16.6621 18.8065 16.5603 18.7018 16.5178L6.47588 11.5479C6.31829 11.4839 6.13913 11.5758 6.12861 11.7456C6.12621 11.7843 6.125 11.8232 6.125 11.8623V27.3001C6.125 28.0668 6.59178 28.7562 7.30364 29.041L18.4941 33.5171ZM18.468 3.23229C19.4515 2.83891 20.5485 2.83891 21.532 3.23229L33.532 8.03229C34.2141 8.30512 34.7944 8.74737 35.2317 9.29865C35.7976 10.0123 36.125 10.9103 36.125 11.8623V27.3001C36.125 28.9868 35.0981 30.5036 33.532 31.13L21.532 35.93C21.0403 36.1267 20.5201 36.2251 20 36.2251C19.4799 36.2251 18.9597 36.1267 18.468 35.93L6.46801 31.13C4.90192 30.5036 3.875 28.9868 3.875 27.3001V11.8623C3.875 10.9103 4.20236 10.0123 4.76833 9.29865C5.20556 8.74737 5.78593 8.30512 6.46801 8.03229L18.468 3.23229Z",
    fill: "url(#paint0_linear_137_16671)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_137_16671",
    x1: 36.25,
    y1: 8.12479,
    x2: 17.4182,
    y2: 34.3993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE02CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube24Logo);
export default __webpack_public_path__ + "static/media/Cube-24-logo.0de05876b297bd936d2d39f885468854.svg";
export { ForwardRef as ReactComponent };